module.exports = __webpack_public_path__ + "img/h09-min.f1b07d65.png";